import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {FormGroup, FormControl, Validators} from '@angular/forms';

@Component({
  selector: 'app-right-temp-panel',
  templateUrl: './right-temp-panel.component.html',
  styleUrls: ['./right-temp-panel.component.scss']
})
export class RightTempPanelComponent implements OnInit {
  @Input() tempMac;
  @Output() closePanelEvent = new EventEmitter<void>();
  @Output() saveTempEvent = new EventEmitter<void>();
  @Output() deleteTempEvent = new EventEmitter<void>();

  tempMacForm: FormGroup;

  public maskTemp = {
    guide: true,
    showMask: true,
    mask: [/[a-zA-Z0-9]/, /[a-zA-Z0-9]/, ':', /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, ':', /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, ':',
      /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, ':', /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, ':', /[a-zA-Z0-9]/, /[a-zA-Z0-9]/]
  };

  ngOnInit() {
    this.tempMacForm = new FormGroup({
      mac: new FormControl(this.tempMac || '', [
        Validators.required,
        Validators.pattern('^([a-zA-Z0-9-:]){17}$')
      ]),
    });
  }

  closePanel() {
    this.closePanelEvent.emit();
  }

  saveTempMac() {
    if (this.tempMacForm.valid) {
      this.saveTempEvent.emit(this.tempMacForm.value);
    }
  }

  deleteTempMac() {
    this.deleteTempEvent.emit();
  }
}
